@if (tracks.length > 0) {
  <div class="discord_container">
    <h2 #portfolio>currently listening.</h2>
    <div class="trackWrapper">
      @if (tracks[activeTrack - 1]) {
        <div
          id="sliderLeft"
          class="slider_left"
          (click)="forwardTrack()"
          >
          <img
            class="prev_track_img"
            src="{{ tracks[activeTrack - 1].albumImgUrl }}"
            />
            <img class="blur" src="{{ tracks[activeTrack - 1].albumImgUrl }}" />
            <div class="icon"><fa-icon [icon]="faBackward"></fa-icon></div>
          </div>
        }
        @if (tracks[activeTrack]) {
          <a
            (touchstart)="swipe($event, 'start')"
            (touchend)="swipe($event, 'end')"
            class="spotify_card"
            href="{{ tracks[activeTrack].externalUrl }}"
            target="_blank"
            >
            <div class="track_info" id="trackInfo">
              <div class="cover_container">
                <img
                  class="track_img"
                  src="{{ tracks[activeTrack].albumImgUrl }}"
                  />
                  <div class="overlay"><fa-icon [icon]="faPlay"></fa-icon></div>
                </div>
                <span class="track_name">{{ tracks[activeTrack].name }}</span>
                <span class="artist">{{ tracks[activeTrack].artist }}</span>
              </div>
            </a>
          }
          @if (tracks[activeTrack + 1]) {
            <div
              id="sliderRight"
              class="slider_right"
              (click)="backwardTrack()"
              >
              <img
                class="prev_track_img"
                src="{{ tracks[activeTrack + 1].albumImgUrl }}"
                />
                <img class="blur" src="{{ tracks[activeTrack + 1].albumImgUrl }}" />
                <div class="icon"><fa-icon [icon]="faForward"></fa-icon></div>
              </div>
            }
          </div>
        </div>
      }